import React from 'react';
import { useNavigate } from 'react-router-dom';

// Componente para manejar el estado cuando el juego ha terminado
const QuizGameEnd = ({ 
  puntuacion, 
  preguntas, 
  juegoTerminado, 
  tensionSoundRef, 
  tensionSoundFadeOut, 
  reiniciarConcursoCompleto 
}) => {
  const navigate = useNavigate();

  if (juegoTerminado) {
    // Hacer fade out del sonido de tensión cuando se acaba el concurso
    if (tensionSoundRef.current) {
      tensionSoundFadeOut(tensionSoundRef);
    }
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4 dark:bg-opacity-70">
        <div className="bg-white rounded-lg shadow-xl p-5 sm:p-8 max-w-md w-full dark:bg-gray-800 dark:text-white transition duration-300 transform scale-95 animate-in fade-in-90 zoom-in-90">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 dark:text-white">¡Concurso Finalizado!</h2>
          <div className="text-center">
            <p className="text-xl mb-4 dark:text-white">Tu puntuación final: <span className="font-bold dark:text-white">{puntuacion}</span> de {preguntas.length}</p>
            <p className="text-lg mb-6 dark:text-white">Porcentaje de aciertos: <span className="font-bold dark:text-white">{Math.round((puntuacion / preguntas.length) * 100)}%</span></p>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 sm:justify-center">
              <button
                onClick={reiniciarConcursoCompleto}
                className="w-full sm:w-auto bg-blue-600 text-white py-3 px-6 rounded hover:bg-blue-700 transition-colors duration-300 font-semibold dark:bg-blue-700 dark:hover:bg-blue-800"
              >
                Jugar de Nuevo
              </button>
              <button
                onClick={() => navigate('/admin')}
                className="w-full sm:w-auto bg-gray-600 text-white py-3 px-6 rounded hover:bg-gray-700 transition-colors duration-300 font-semibold dark:bg-gray-700 dark:hover:bg-gray-800"
              >
                Volver al Inicio
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null; // Este componente no renderiza nada si el juego no ha terminado
};

export default QuizGameEnd;
